import { api } from './_request';

export const get = () => {
	return (dispatch) => {

		api().get('/descuentos')
		.then(function(response)
		{
			if(response.status === 200)
			{
				dispatch({
					type: 'DESCUENTOS_LIST',
					payload: response.data
				});
			}
		});

	}
}


export const update = (descuentos, callback) => {
	return (dispatch) => {

		api().post(`descuentos/${descuentos.id}`, descuentos)
		.then(function(response)
		{
			if(response.status === 200)
			{
				dispatch({
					type: 'DESCUENTOS_UPDATE_SUCCESS',
					payload: response.data
				});

				if(typeof callback === 'function') callback();
			}
			else
			{
				dispatch({ type: 'DESCUENTOS_SAVE_FAILURE' });
			}
		})
		.catch(function(error) {
			dispatch({ type: 'DESCUENTOS_SAVE_FAILURE' });
		});

	}
}


// WEBPACK FOOTER //
// ./src/actions/descuentos.js